import { userFacingError } from "../authorization";
import { type Schema, zql } from "../generatedDrizzleSchema";
import type { Transaction } from "@rocicorp/zero";

// Blocks anyone who contributed to a branch from publishing it live when its
// space requires a second approver: if you worked on the branch, someone else
// has to push it. Resolves the contributors and space from rows by id rather
// than trusting a caller-passed shape, so it holds identically on the
// optimistic (client) and authoritative (server) mutator paths — the server
// result is the one that wins, so the guard must run there too. The cheap
// disqualifier (the space flag) is checked before the contributor read so the
// common case (feature off) short-circuits with one query.
export async function assertNotSelfApproval(
  tx: Transaction<Schema>,
  actingUserId: string,
  sourceBranchId: string,
  workflowId: string
) {
  const workflow = await tx.run(zql.workflows.where("id", workflowId).one());
  if (!workflow) return;
  const space = await tx.run(zql.spaces.where("id", workflow.spaceId).one());
  if (!space?.blockSelfApproval) return;

  const contributor = await tx.run(
    zql.branchContributors
      .where("branchId", sourceBranchId)
      .where("userId", actingUserId)
      .one()
  );
  if (!contributor) return;
  throw userFacingError(
    "This space requires a different user to push branches live"
  );
}
